import React from 'react';

import ReactDOM from 'react-dom';

import { ReactComponent as CloseIcon } from '../../../../../assets/icons/v3/close.svg';
import { GenericVoidFunction } from '../../../../types/genericTypes';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';

import './CustomModal.scss';

interface ICustomModalProps {
  onClose?: (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => void;
  open: boolean;
  customClass?: string;
  onBackdropClick?: GenericVoidFunction;
}

const CustomModal = ({
  open,
  onClose,
  customClass,
  children,
  onBackdropClick
}: React.PropsWithChildren<ICustomModalProps>) => {
  if (!open) {
    return null;
  }

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && onBackdropClick) {
      onBackdropClick(e);
    }
  };

  return ReactDOM.createPortal(
    <div className="custom-modal-backdrop" onClick={handleBackdropClick}>
      <div className={`custom-modal-container-v3 ${customClass ?? ''}`}>
        <div className="custom-modal-content">
          {onClose && (
            <div className="custom-modal-close">
              <BdsIconButton icon={{ component: CloseIcon }} action={onClose} variant="secondary" size="sm" />
            </div>
          )}
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CustomModal;
